module.exports = __webpack_public_path__ + "static/media/xls.63dfc363.svg";